import React, { useEffect, useRef } from 'react';
import classes from './About.module.css';

const About = (props) => {
  const textInput = useRef();

  useEffect(() => {
    textInput.current.focus();
  }, []);
  const containerClasses = [classes.InputContainer];
  if (props.shortWindow === true) containerClasses.push(classes.ShortWindow);
  return (
    <div className={containerClasses.join(' ')}>
      <div className={classes.TextAreaWrapper}>
        <textarea
          {...props.elementConfig}
          id="about-textarea"
          value={props.value}
          onChange={props.changed}
          onBlur={props.blurred}
          onClick={props.clicked}
          placeholder="Add insights, memories, meaningful information"
          readOnly={props.readOnly}
          ref={textInput}
          className={classes.AboutInput}
        />
      </div>
    </div>
  );
};

export default About;
